module.exports = __webpack_public_path__ + "static/media/browse_practitioners.5d679733.png";